'use server';

export async function getCurrentOnCall() {
    console.log('HERE');
    return [
        {
            name: "timmy",
            on_time: "2:00pm",
            off_time: "5:00pm",
            active: true
        },
        {
            name: "sammy",
            on_time: "5:00pm",
            off_time: "8:00pm",
            active: true
        }
    ];
}